module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Regular-c2113bc6079734d35c72aecd27452795.otf";